<template>
  <div class="col-table-column"></div>
</template>

<script>
export default {
  name: 'ColTableColumn',
  props: {
    label: {
      type: String,
      default: ''
    },
    prop: {
      type: String,
      default: ''
    },
    css: {
      type: Object,
      default: () => {}
    },
    rowStyle: {
      type: Object,
      default: () => {}
    },
    rowClass: {
      type: Array,
      default: () => []
    }
  }
}
</script>
